<template>
    <div class="My_popup">
        <div class="My_popup_wrap">
            <span class="My_popup_close"><a href="#" @click.prevent="closeClickHandler">닫기</a></span>
            <div class="My-popup-title"><span class="color-skyblue">상수도</span></div>
            <div class="waterworks-map">
                <DrawRegionNaverMap />
            </div>
            <div class="My-popup-content">
                <div class="waterworks-pop">
                    <div class="pop_title">상수도 수질정보</div>
                    <ul class="water-chart-bar bdr-none">
                        <li>수질 정상</li>
                        <li>수질 이상</li>
                        <li>점검중</li>
                    </ul>
                </div>
            </div>

            <WaterQaInfoWin v-show="false"
                v-on:loaded-water-qa-info="loadedWaterQaInfoHandler"
                ref="waterQaInfoWin"/>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { $WC } from '@/conf/common.const.js';
import NaverMapMixin from "@/store/naver.map.local.mixin.js"
import DrawRegionNaverMap from "@/components/DrawRegionNaverMap.vue";
import WaterQaInfoWin from "@/views/realtime/WaterQaInfoWin.vue";

export default {
    name: 'WaterQaMapWin',
    data() {
        return {
            waterRoadPolylines: [],
            waterReservoirMarkerKey: 'waterReservoir',
            waterFaucetMarkerKey: 'waterFaucet',
        }
    },
    computed: {
        ...mapGetters({
            waterRoadList: 'getWaterRoadList',
            waterQualityMap: 'getWaterQualityMap',
            waterReservoirList: 'getWaterReservoirList',
            waterFaucetList: 'getWaterFaucetList',
        }),
    },
    created() {
        let waterRoadListWatch = this.$watch("waterRoadList", val => {
            this.drawWaterRoad();
            this.placeMarker();
            waterRoadListWatch();
        });

        this.$eventBus.$once('NaverMap::map-loaded', map => {
            this.naverMaps = map;
        });

        this.$eventBus.$once("DrawRegionNaverMap::completed-draw-region", geoJsonDrawing => {
            this.geoJsonDrawing = geoJsonDrawing;
            this.drawWaterRoad();
            this.placeMarker();
        });
    },
    methods: {
        closeClickHandler() {
            this.$emit("close-water-qa-map-win");
        },
        // 물길 그리기
        drawWaterRoad() {
            if(typeof this.waterRoadList !== $WC.UNDEF && typeof this.geoJsonDrawing !== $WC.UNDEF) {
                this.waterRoadList.forEach(road => {
                    let polylineWhite = new naver.maps.Polyline({
                        map: this.naverMaps,
                        strokeWeight: 8,
                        strokeColor: '#FFFFFF',
                        strokeLineCap: 'round',
                        endIcon: naver.maps.PointingIcon.BLOCK_ARROW,
                        path: [
                            new naver.maps.LatLng(road.val1, road.val2),
                            new naver.maps.LatLng(road.val3, road.val4)
                        ]
                    });
                    this.waterRoadPolylines.push(polylineWhite);

                    let polyline = new naver.maps.Polyline({
                        map: this.naverMaps,
                        strokeWeight: 6,
                        strokeColor: '#908e8f',
                        strokeLineCap: 'round',
                        endIcon: naver.maps.PointingIcon.BLOCK_ARROW,
                        path: [
                            new naver.maps.LatLng(road.val1, road.val2),
                            new naver.maps.LatLng(road.val3, road.val4)
                        ]
                    });
                    polyline.mappingFac = road.val5;
                    this.waterRoadPolylines.push(polyline);
                });
            }

            this.chnageWaterRoadState();
        },

        // 물길 정보 변경
        chnageWaterRoadState() {
            this.waterRoadPolylines.forEach(polyline => {
                let mappingNm = polyline.mappingFac;
                if(typeof mappingNm !== $WC.UNDEF && this.waterQualityMap[mappingNm] !== $WC.UNDEF) {
                    let state = this.waterQualityMap[mappingNm].state;
                    if(state == 1) {
                        polyline.setOptions("strokeColor", "#269CF9");
                    } else if(state == -1) {
                        polyline.setOptions("strokeColor", "#F7262D");
                    } else {
                        polyline.setOptions("strokeColor", "#908E8F");
                    }
                }
            });
        },

        // 마커 놓기
        placeMarker() {
            // 배수지 정보
            this.waterReservoirList.forEach(waterReservoir => {
                waterReservoir.marker = this.makeMarker(this.waterReservoirMarkerKey, waterReservoir, () => {
                    let waterQaInfo = this.waterQualityMap[waterReservoir.val1];
                    this.$refs.waterQaInfoWin.setWaterQaInfo(waterQaInfo);
                }, 'marker_' + this.waterReservoirMarkerKey + '.png', 'images/marker/', 28, 35);
            });
            this.showMarkers(this.waterReservoirMarkerKey, true);

            // 수도꼭지 정보
            this.waterFaucetList.forEach(waterFaucet => {
                waterFaucet.marker = this.makeMarker(this.waterFaucetMarkerKey, waterFaucet, () => {
                    let waterQaInfo = this.waterQualityMap[waterFaucet.val1];
                    this.$refs.waterQaInfoWin.setWaterQaInfo(waterQaInfo);
                }, 'marker_' + this.waterFaucetMarkerKey + '.png', 'images/marker/', 28, 35);
            });
            this.showMarkers(this.waterFaucetMarkerKey, true);
        },

        // 배수지 및 수도꼭지 정보 팝업
        loadedWaterQaInfoHandler(content) {
            this.openInfoWin(content);
        },
    },
    mixins: [NaverMapMixin],
    components: {
        DrawRegionNaverMap,
        WaterQaInfoWin,
    }
}
</script>
